export default __webpack_public_path__ + "static/OperatorMono-Bold_Web-3a7734be68187b10617cab5727ab92d0.woff2";